import dotProp from "dot-prop";
import React from 'react'
import { connect } from 'react-redux'
import { fetchEntities } from "../../../actions/entities";
import { discardDraft, resumeDraft } from "../../../logic/dossierItems/draftPersist";
import dossierItemSchema from "../../../forms/dossierItemSchema";
import { getCurrentEmployment } from "../../../selectors/employments";
import SchemaForm from "../../forms/SchemaForm";

const draftModel = (entityId) => `entities.dossierItem.byId.${entityId}`

class DossierItemForm extends React.Component {

  componentDidMount() {
    this.props.fetchTemplates();
    this.props.resumeDraft();
  }

  componentWillUnmount() {
    this.props.discardDraft()
  }

  render() {
    return (
      <SchemaForm entityName='dossierItem' {...this.props}/>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  let dossierItemType = dotProp.get(state, `entities.dossierItem.byId.${ownProps.entityId}.dossierItemType`)
  return {
    uiSchema: dossierItemSchema(state, ownProps, dossierItemType)
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchTemplates: () => {
      return dispatch(fetchEntities('templates'))
    },
    resumeDraft: () => resumeDraft(draftModel(ownProps.entityId)),
    discardDraft: () => dispatch((dispatch, getState) => {
      const employment = getCurrentEmployment(getState())
      if (!employment?.id) return
      discardDraft(draftModel(ownProps.entityId), employment)
    })
  };
}

DossierItemForm.defaultProps = {
  submitButton: true
}

export default connect(mapStateToProps, mapDispatchToProps)(DossierItemForm);
